import Quill from 'quill';
const BlockEmbed = Quill.import('blots/embed');

class FileBlot extends BlockEmbed {
    static create(value) {
        
        let mimeType = value.mime_type;
        let icon = "fa-file";
        let text = "text-slate-600";
        let textHover = "text-slate-200";
        let dataType = "iframe";        
//        const showRemove = window.isEditing;
        
        let node = super.create();
        node.setAttribute('data-id', value.id);
        node.setAttribute('data-url', value.url);
        node.className = "file-blot";
        
        if ( mimeType.includes("pdf") ) {
            icon = "fa-file-pdf";
            text = "text-[#E44B4D]";
            textHover = "text-[#B91C1C]";
            dataType = "pdf";            
        }
        else if ( mimeType.includes("word") ) {
            icon = "fa-file-word";
            text = "text-[#2b579a]";
            textHover = "text-[#3b71ca]";
            value.url = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(value.url)}`;
        }
        else if ( mimeType.includes("sheet") ) {
            icon = "fa-file-excel";
            text = "text-[#1D6F42]";
            textHover = "text-[#219653]";
            value.url = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(value.url)}`;
        }
        else if ( mimeType.includes("powerpoint") ) {
            icon = "fa-file-powerpoint";
            text = "text-[#DF4818]";
            textHover = "text-[#DF4818]";
            value.url = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(value.url)}`;
        }
        else if ( mimeType.includes("text") ) {
            icon = "fa-file-lines";
            text = "text-[#3B3B3B]";
            textHover = "text-[#000000]";
            dataType = "pdf";
        }
        else if ( mimeType.includes("image") ) {
            icon = "fa-image";
            text = "text-[#9631A1]";
            textHover = "text-[#D17B88]";
            dataType = "image";
        }
        
        let fancyBox = icon === "fa-file" ? "download" : `data-fancybox data-type="${dataType}"`;
        let buttonRemove = `<button class="remove-btn hover:bg-slate-300 size-7 rounded-full cursor-pointer flex items-center justify-center" onclick="this.dispatchEvent(new CustomEvent('remove-file', {bubbles: true, detail: '${value.id}'}))"><i class="fal fa-times fa-fw fa-lg text-slate-600"></i></button>`;
        
        
        // Crear el contenedor visual
        if ( dataType === "image" ) {
            node.innerHTML = `<span class="inline-flex rounded-lg w-fit"><a href="${value.url}" data-fancybox data-type=${dataType}><img class="w-full" src="${value.url}" /></a></span>`;
        }
        else {
            node.innerHTML = `<span class="inline-flex items-center gap-3 w-fit p-3 rounded-xl bg-slate-50 border-slate-100 hover:bg-slate-200 ${text}"><a class="flex items-center" ${fancyBox} target="_blank" href="${value.url}"><i class="fa-duotone ${icon} fa-fw fa-2x"></i>${value.name}</a>${buttonRemove}</span>`;
        }
        
        return node;
    }

    static value(node) {
        return {
            id: node.getAttribute('data-id'),
            url: node.getAttribute('data-url')
        };
    }
}
FileBlot.blotName = 'file-attachment';
FileBlot.tagName = 'span'; // O 'div' si prefieres que sea bloque
Quill.register(FileBlot);